import * as React from "react"
import { graphql } from "gatsby"
import InnerHTML from 'dangerously-set-html-content'

const PrismicPageDataBodyRawHtml = ({ primary }) => {

  return (
    <InnerHTML html={primary.html} />
  )
}
export default PrismicPageDataBodyRawHtml

export const query = graphql`
    fragment HTML on PrismicPageDataBodyRawHtml {
      slice_type
      slice_label
      __typename
      id
        primary {
            html
        }
    }
`
